<template>
<transition name="modal">
<div id="buyInShopModal" class="buyInShopModal">
  <div class="buyInShopModal__window">
    <p class="buyInShopModal__window__title">ご購入ありがとうございます</p>
    <p class="buyInShopModal__window__content">注文・発注手続きを行いますので、<br />恐れ入りますが店舗スタッフをお呼びください。</p>
    <div class="buyInShopModal__window__id">カスタムID: {{ customID }}</div>
    <p class="buyInShopModal__window__alert">※ HOME画面に戻るとカスタマイズデータは消去されます。</p>
    <router-link to="/mirror" class="buyInShopModal__window__backbtn">HOME画面に戻る</router-link>
  </div>
</div>
</transition>
</template>

<script>
export default {
  props: {
    customID: String
  }
}
</script>

<style lang="scss" scoped>
.buyInShopModal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  transition: all .3s ease;
  background: rgba(#111, 0.7);
  line-height: 1.5;
  &__window {
    text-align: center;
    width: 700px;
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -350px;
    padding: 50px 50px 0 50px;
    background-color: $base-white;
    &__title {
      font-size: 35px;
      font-weight: bold;
    }
    &__content {
      margin-top: 30px;
      font-size: 22px;
    }
    &__id {
      margin-top: 30px;
      padding: 20px 15px;
      border: 5px solid $base-black;
      font-size: 28px;
      font-weight: bold;
    }
    &__alert {
      font-size: 20px;
      margin-top: 30px;
      color: $red;
      font-weight: bold;
    }
    &__backbtn {
      display: block;
      background-color: $base-black;
      color: $base-white;
      margin: 50px -50px 0;
      padding: 30px 0;
      font-size: 30px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mirror/BuyInShopModal.vue